<template>
  <div class="rotations-popup" :class="device">
    <div class="popup-header">
      <div class="heading">
        <span class="title">{{ $t('hose.compared') }}</span>
        <span class="close-btn" @click="$emit('close')">&times;</span>
      </div>
    </div>

    <div class="rotation-options">
      <rotation-card
          v-for="option in rotationOptions"
          :key="option.id"
          :rotation="option"
          v-model="rotation"
      ></rotation-card>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import RotationCard from "@/components/hose/components/RotationCard";

export default {
  name: "RotationPopup",
  components: {RotationCard},
  computed: {
    ...mapGetters({
      preferences: 'build/hoses/getHosePreferences',
      build: "build/hoses/getHoseBuild",
      rotationOptions: "build/hoses/couplings/getAllRotations",
      device: "getDevice",
    }),
    rotation: {
      get() {
        return this.build.rotation;
      },
      set(val) {
        this.$store.commit('build/hoses/setRotation', val);
        this.$emit('close');
      },
    },
  }
}
</script>

<style scoped lang="scss">
.rotations-popup {
  display: flex;
  flex-direction: column;
  padding: 20px 19px;

  .popup-header {
    display: flex;
  }

  .heading {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 20px;
      font-family: neue-haas-grotesk-display, sans-serif;
    }
  }

  .close-btn {
    color: #A4AFB7;
    font-size: 40px;
    cursor: pointer;
    transition: all ease 0.3s;

    &:hover {
      color: darken(#A4AFB7, 40%);
    }
  }
}

.rotation-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 0;
  justify-content: center;
}
</style>
